import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Copy, Download } from "lucide-react";
import { toast } from "sonner";

export const enrollUrl = (base, slug) => `${(base || window.location.origin).replace(/\/$/, "")}/enroll/${slug}`;

export function PackageQR({ pkg, base, size = 180 }) {
  const ref = useRef(null);
  const url = enrollUrl(base, pkg.slug);
  const download = () => {
    const canvas = ref.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `gia-care-qr-${pkg.slug}.png`;
    a.click();
  };
  return (
    <div className="flex flex-col items-center gap-3" data-testid={`package-qr-${pkg.slug}`}>
      <div ref={ref} className="rounded-2xl border border-slate-100 bg-white p-3 shadow-sm" data-testid={`package-qr-canvas-${pkg.slug}`}>
        <QRCodeCanvas value={url} size={size} fgColor="#4C1D95" level="M" includeMargin imageSettings={{ src: "/icon-192.png", height: size * 0.2, width: size * 0.2, excavate: true }} />
      </div>
      <p className="max-w-[240px] break-all text-center font-mono text-[11px] text-slate-500" data-testid="package-qr-url">{url}</p>
      <div className="flex gap-2">
        <button className="btn-secondary btn-sm" onClick={() => { navigator.clipboard?.writeText(url); toast.success("Link copied"); }} data-testid={`copy-qr-url-${pkg.slug}`}><Copy size={13} /> Copy link</button>
        <button className="btn-primary btn-sm" onClick={download} data-testid={`download-qr-${pkg.slug}`}><Download size={13} /> PNG</button>
      </div>
    </div>
  );
}
